<template>
  <div class="job-category">
    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.name" label="Asset Name"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.org" label="Organisation"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.group" label="Group"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.make" label="Asset Make"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.model" label="Asset Model"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.year" label="Year"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.imei" label="IMEI"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.serial_number" label="Serial"></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Logger } from "aws-amplify";
const logger = new Logger("Advanced Search / Assets");
import { pageCache } from '@/mixins/page-cache.js';

export default {
  name: "Assets",
  mixins: [
    pageCache('globalsearchassets')
  ],
  props: {
    reset: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      searching: false,
      search: {
        status: "",
        org: "",
        group: "",
        name: "",
        imei: "",
        iccid: "",
        serial_number: "",
        make: "",
        model: "",
        firmware_version: "",
        year: "",
      },
    };
  },
  watch: {
    search: {
      handler(val) {
        this.$emit("updatedSearchCriteria", val);
      },
      deep: true,
    },
    reset() {
      this.resetFields();
    },
  },
  mounted() {},
  methods: {
    resetFields() {
      logger.info("clear them fields");

      for (var key in this.search) {
        if (this.search.hasOwnProperty(key)) {
          this.search[key] = "";
        }
      }
    },
  },
};
</script>
